import * as types from "../../constants";
import { ActionsOf, init } from "../utils";
import * as actions from "../actions-declarations/facilities";

type FacilitiesActions = typeof actions;

export type FacilitiesActionType = {
  facilities: string[];
};

export type FacilitiesType = {
  facilities?: any;
};

export default function reducer(
  state = init({
    facilities: [] as string[]
  }),
  actions: ActionsOf<FacilitiesActions>
): typeof state {
  switch (actions.type) {
    case "SET_FACILITIES":
      return {
        ...state,
        facilities: actions.facilities,
      };
    default:
      return state;
  }
}
